// extracted by mini-css-extract-plugin
module.exports = {"imageuploadcontainer":"ProfileImage__imageuploadcontainer--2YTsr","edit":"ProfileImage__edit--iXIIa","image":"ProfileImage__image--27L7N","label":"ProfileImage__label--1DEuL"};